import axios from 'axios';
import { zabeleziOdziv } from './apiLog'; // [PATCH napake-fe v1]

const API_URL = process.env.REACT_APP_API_URL || '/api/v1';

export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => { zabeleziOdziv(r.config, r.status); return r; }, // [PATCH napake-fe v1]
  (error) => {
    zabeleziOdziv(error.config, error.response?.status, error.message); // [PATCH napake-fe v1]
    const _url = String(error.config?.url || ''); // [PATCH 2fa v1b] login 401 ostane na obrazcu
    if (error.response?.status === 401 && !_url.includes('/auth/login')) {
      localStorage.removeItem('token');
      window.location.href = '/prijava';
    }
    return Promise.reject(error);
  }
);
